export const root = {
  fontSize: '0.750rem',
  roundedBorderRadius: '0.5rem',
  fontWeight: '600',
  iconSize: '0.750rem',
};

export default {
  root,
  css: ({}) => {
    return `.p-tag { line-height: 1rem; }`;
  },
};
